export const SimulationLandingPageTemplate = {
    slots: ['SlbCheckoutContainerSlot'],
};